module.exports = __webpack_public_path__ + "img/logo_short_szp.9306fc8e.png";